var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F5F8FF",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.875 18H26.75C26.75 17.0054 26.3549 16.0516 25.6517 15.3483C24.9484 14.6451 23.9946 14.25 23 14.25C22.0054 14.25 21.0516 14.6451 20.3483 15.3483C19.6451 16.0516 19.25 17.0054 19.25 18H16.125C15.7935 18 15.4755 18.1317 15.2411 18.3661C15.0067 18.6005 14.875 18.9185 14.875 19.25V28.625C14.875 28.9565 15.0067 29.2745 15.2411 29.5089C15.4755 29.7433 15.7935 29.875 16.125 29.875H29.875C30.2065 29.875 30.5245 29.7433 30.7589 29.5089C30.9933 29.2745 31.125 28.9565 31.125 28.625V19.25C31.125 18.9185 30.9933 18.6005 30.7589 18.3661C30.5245 18.1317 30.2065 18 29.875 18ZM23 15.5C23.663 15.5 24.2989 15.7634 24.7678 16.2322C25.2366 16.7011 25.5 17.337 25.5 18H20.5C20.5 17.337 20.7634 16.7011 21.2322 16.2322C21.7011 15.7634 22.337 15.5 23 15.5ZM29.875 28.625H16.125V19.25H19.25V20.5C19.25 20.6658 19.3158 20.8247 19.4331 20.9419C19.5503 21.0592 19.7092 21.125 19.875 21.125C20.0408 21.125 20.1997 21.0592 20.3169 20.9419C20.4342 20.8247 20.5 20.6658 20.5 20.5V19.25H25.5V20.5C25.5 20.6658 25.5658 20.8247 25.6831 20.9419C25.8003 21.0592 25.9592 21.125 26.125 21.125C26.2908 21.125 26.4497 21.0592 26.5669 20.9419C26.6842 20.8247 26.75 20.6658 26.75 20.5V19.25H29.875V28.625Z",
    fill: "#797F8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.f34add4648fb9b8e4101775157851b10.svg";
export { ForwardRef as ReactComponent };